import {buildDescriptorControl} from "../descriptorcontrols/ControlResolver";

export default (props) => buildDescriptorControl("IntegerField", "spinner", props);



// WEBPACK FOOTER //
// ./app/lib/common/controls/Integer.js